import axios from 'axios'
import {Logic} from '../Type'
import {Main} from '../Main'
import * as Assets from '../../Assets/Assets'
import * as Config from '../Config'
import * as App from './app'
import * as moment from 'moment'

export function filterRST(zero: boolean) {
    let from: string = Main.Instance.IndexState.from_date ? moment(Main.Instance.IndexState.from_date).format(Assets.dateFormatDisplay).trim() : Assets.none
    let to: string = Main.Instance.IndexState.to_date ? moment(Main.Instance.IndexState.to_date).format(Assets.dateFormatDisplay).trim() : Assets.none
    
    axios.get(Config.promostoreServerAllPlayerRST + '?site_id=' + Main.Instance.IndexState.Site + '&player=' + Main.Instance.IndexState.Name
    + '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to)
    .then ((response) => {
        App.GetRewardShopTransactions(Main.Instance.IndexState.Site, Main.Instance.IndexState.Name)
        if (zero) Logic.Type.New (Main.Instance.IndexState, {allPlayerRst: response.data, pNum: 0, offset: '0'})
        else Logic.Type.New (Main.Instance.IndexState, {allPlayerRst: response.data})
    })
}
/*
export function existsPlayer (callback:() => void, create: boolean) {
    let str = Config.adminServerUserData 
    + '?user=' + Main.Instance.IndexState.UsernameNew + '&site=' + Main.Instance.IndexState.Site

    axios.get(str)
      .then(response => {
        if (response.data.id) {
          if (create || !create && Main.Instance.IndexState.UsernameNew !== Main.Instance.LoginState.Username) {
            Logic.Type.New (Main.Instance.LoginState, {PlayerExists:true})
          } else {
            callback()
          }
        } else {
          callback()
        }
    })
}
*/
export function NotifyLogout() {
  axios.post (Config.promostoreServerLogout, {
    user: Main.Instance.LoginState.Username, site: Main.Instance.IndexState.Site})  
}

function NotifyLogin(site: string) {  
  axios.post (Config.promostoreServerLogin, {user: Main.Instance.LoginState.Username, site})  
}

export function Login(autologin?: any) {
    if (Main.Instance.IndexState.Site && parseInt(Main.Instance.IndexState.Site) !== 0)
        authorizePlayer(Main.Instance.IndexState.Site, autologin)
}

export function authorizePlayer(site: string, autologin?: any) {

  if (Main.Instance.LoginState.Username.length === 0 && autologin === undefined) {

    Logic.Type.New (Main.Instance.LoginState, {
        PasswordIncorrect: false,
        UsernameEmpty: true,
        // Name: '',
        // Mail: '',
        Balance : '0',
        // Currency: Assets.CurrencyEUR
    })    
  } else {
    if (autologin !== undefined && autologin.player !== undefined) {
        Logic.Type.New (Main.Instance.LoginState, {
            Balance: '0',
            Verified: true, 
            PasswordIncorrect: false,
            UsernameEmpty: false,
            // Name: autologin.player.toString(), 
            // Mail: autologin.player.toString(), 
            // Mode: false,
            // Currency: Assets.CurrencyEUR
        })

        axios.get(Config.promostoreServerAllPlayerRST + '?site_id=' + site + '&player=' + autologin.player)
        .then ((response) => {
            App.GetRewardShopTransactions(site, autologin.player.toString())
            Logic.Type.New (Main.Instance.IndexState, { 
                Email: autologin.player.toString(),
                Id: autologin.player.toString(),
                Name: autologin.player.toString(),
                Username: autologin.player.toString(),
                Password: autologin.player.toString(),
                rstStream: undefined,
                // RstStream: undefined,
                RSTStream: undefined,
                PointsXP: autologin.xp,
                PointsXPL: autologin.xpl,
                PlayerLevel: +autologin.level,
                PlayerSubLevel: +autologin.sublevel,
                allPlayerRst: response.data,
                // AllPlayerRst: response.data
            })
            NotifyLogin(site)
        })
    }
  }
}


// WEBPACK FOOTER //
// ./src/Logic/Database/Rest.ts